const DAY = 86_400_000

function parseIso(iso: string): Date {
  const [y = 0, m = 1, d = 1] = iso.split('-').map(Number)
  return new Date(y, m - 1, d)
}

export function monthsSince(iso: string, now = new Date()): number {
  const start = parseIso(iso)
  let months = (now.getFullYear() - start.getFullYear()) * 12 + (now.getMonth() - start.getMonth())
  if (now.getDate() < start.getDate()) months -= 1
  return Math.max(months, 0)
}

export function tenureParts(iso: string, now = new Date()): { years: number; months: number } {
  const total = monthsSince(iso, now)
  return { years: Math.floor(total / 12), months: total % 12 }
}

export function daysUntil(iso: string, now = new Date()): number {
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
  return Math.round((parseIso(iso).getTime() - today.getTime()) / DAY)
}

export function daysSince(iso: string, now = new Date()): number {
  return -daysUntil(iso, now)
}

export function addDaysIso(iso: string, days: number): string {
  const d = parseIso(iso)
  d.setDate(d.getDate() + days)
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
}

export function isoToDmy(iso: string): string {
  const [y, m, d] = iso.split('-')
  return `${d}.${m}.${y}`
}
